<template>
    <div class="row">
        <div class="col-md-6 text-center">
            <img :src="profileImage" class="img-fluid img-thumbnail rounded-circle img-profile" />
        </div>
        <div class="col-md-6">
            <div class="form-horizontal" v-if="!!user">
                <div class="form-group row">
                    <label for="name" class="col-form-label col-md-4">Bedrijfsnaam:</label>
                    <div class="col-md-8">
                        <input class="form-control-plaintext" id="companyName" name="companyName" disabled placeholder="Bedrijfsnaam" v-model="fullName" /> 
                    </div>
                </div>
                <div class="form-group row">
                    <label for="companyAddress" class="col-form-label col-md-4">Adres:</label>
                    <div class="col-md-8">
                        <input class="form-control-plaintext" id="companyAddress" name="companyAddress" disabled placeholder="Adres" v-model="profile.address" /> 
                    </div>
                </div>
                <div class="form-group row">
                    <label for="companyPostalCode" class="col-form-label col-md-4">Postcode:</label>
                    <div class="col-md-8">
                        <input class="form-control-plaintext" id="companyPostalCode" name="companyPostalCode" disabled placeholder="Postcode" v-model="profile.postalCode" /> 
                    </div>
                </div>
                <div class="form-group row">
                    <label for="companyCity" class="col-form-label col-md-4">Plaats:</label>
                    <div class="col-md-8">
                        <input class="form-control-plaintext" id="companyCity" name="companyCity" disabled placeholder="Plaats" v-model="profile.city" /> 
                    </div>
                </div>
            </div>
            
            <hr>
            <div class="form-horizontal" v-if="!!user">
                <div class="form-group row">
                    <label for="companyPhone" class="col-form-label col-md-4">Telefoonnummer:</label>
                    <div class="col-md-8">
                        <input class="form-control-plaintext" id="companyPhone" name="companyPhone" disabled placeholder="Telefoonnummer" v-model="user.phoneNumber" /> 
                    </div>
                </div>
                <div class="form-group row">
                    <label for="companyEmail" class="col-form-label col-md-4">Email:</label>
                    <div class="col-md-8">
                        <input class="form-control-plaintext" id="companyEmail" name="companyEmail" disabled placeholder="Email" v-model="user.email" /> 
                    </div>
                </div>
                <div class="form-group row">
                    <label for="companyWebsite" class="col-form-label col-md-4">Website:</label>
                    <div class="col-md-8">
                        <input class="form-control-plaintext" id="companyWebsite" name="companyWebsite" disabled placeholder="https://" v-model="profile.website" /> 
                    </div>
                </div>
            </div>
            <hr>
            <label class="col-form-label" for="police-unit">Eenheid Politie</label>
            <select class="form-control" v-model="profile.policeUnitId" @change="savePoliceUnit(profile.policeUnitId)" name="police-unit" id="police-unit" :disabled="isLoading"> 
                <option :value="u.id" v-for="u in $store.getters.policeUnits" :key="u.id" >{{u.name}}</option>
            </select>           
        </div>
        <vue-toastr ref="toastr"></vue-toastr>
    </div>
</template>

<script>
import VueToastr from "vue-toastr";
export default {
    props: ['user'],
    components: {
        VueToastr,
    },
    data() {
        return {
            isLoading: false
        }
    },
    mounted() {
        this.$refs.toastr.defaultPosition = "toast-bottom-right";
        this.$store.dispatch('GET_POLICEUNITS');
    },
    methods: {
        savePoliceUnit(id) {
            this.isLoading = true;
            this.$http.post('api/policeunits/' + id).then((res) => {
                this.isLoading = false;
                this.$refs.toastr.s("Eenheid Politie is aangepast.");
                let user = Object.assign({}, this.$store.getters.user);
                user.policeUnitId = id;
                this.$store.commit("SET_USER", user);
                this.$emit('editPoliceUnit', id);
            }).catch(() => {
                this.isLoading = false;
                this.$refs.toastr.e("Aanpassen eenheid Politie is mislukt.");
            })
        }
    },
    computed: {
        profile() {
            if(this.user)
                return this.user.clientProfile;
            return {};
        },
        fullName() {
            return this.profile.company;
        },
        profileImage() {
            if(this.profile)
            {
                const image = this.profile.profileImage;
                if(image)
                    return 'data:' + image.fileContentType + ";base64," + image.file;
            }
        }
    }
}
</script>

<style scoped>
.img-profile {
    width: 75%;
    height: 75%;
}
</style>
